import { render, staticRenderFns } from "./EdicaoEmPlanilha.vue?vue&type=template&id=556a8604&"
import script from "./EdicaoEmPlanilha.vue?vue&type=script&lang=js&"
export * from "./EdicaoEmPlanilha.vue?vue&type=script&lang=js&"
import style0 from "./EdicaoEmPlanilha.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports